import { apiClient } from './axios';

/** Un pacient identificat ca dată de test. */
export interface TestDataPatient {
  id: string;
  firstName: string | null;
  lastName: string | null;
  cnp: string | null;
  email: string | null;
  address: string | null;
  deletedAt: string | null;
  /** De ce a fost recunoscut ca dată de test. */
  reason: string;
  /** Pacient șters logic: nu mai apare în listă, se curăță doar prin SQL. */
  softDeleted: boolean;
}

/** Un formular rămas fără pacient (orfan). */
export interface OrphanForm {
  kind: 'dermato' | 'hepato';
  id: string;
  patientId: string | null;
  createdAt: string | null;
}

export interface TestDataCounts {
  dermatoForms: number;
  hepatoForms: number;
  lesions: number;
  documents: number;
  orphanForms: number;
}

export interface TestDataInventory {
  patients: TestDataPatient[];
  orphanForms: OrphanForm[];
  counts: TestDataCounts;
}

export interface TestDataCleanupReport extends TestDataInventory {
  deleted: {
    patients: number;
    dermatoForms: number;
    hepatoForms: number;
    lesions: number;
    documents: number;
  };
  warnings: string[];
}

const unwrap = <T>(responseData: any): T => responseData?.data ?? responseData;

export const adminApi = {
  /** Inventarul datelor de test — nu șterge nimic. */
  getTestDataInventory: async (): Promise<TestDataInventory> => {
    const response = await apiClient.get('/admin/test-data');
    return unwrap<TestDataInventory>(response.data);
  },

  /** Curățarea datelor de test identificate. */
  cleanupTestData: async (includeOrphans: boolean): Promise<TestDataCleanupReport> => {
    const response = await apiClient.post('/admin/test-data/cleanup', { includeOrphans });
    return unwrap<TestDataCleanupReport>(response.data);
  },
};
